export type LeadFilterMode =
  | "active"
  | "all"
  | "new"
  | "qualified"
  | "converted";

export const leadFilterKeys = [
  "lead_status",
  "converted_project_id@is",
  "converted_project_id@not.is",
] as const;

export const leadFilterValues: Record<
  LeadFilterMode,
  Record<string, unknown>
> = {
  active: { "converted_project_id@is": null },
  all: {},
  new: { lead_status: "new", "converted_project_id@is": null },
  qualified: { lead_status: "qualified", "converted_project_id@is": null },
  converted: {
    "converted_project_id@not.is": null,
    lead_status: "qualified",
  },
};

export const getLeadFilterMode = (
  filters: Record<string, unknown>,
): LeadFilterMode => {
  if (filters["converted_project_id@not.is"] !== undefined) return "converted";
  if (filters.lead_status === "qualified") return "qualified";
  if (filters.lead_status === "new") return "new";
  if (filters["converted_project_id@is"] === null) return "active";
  return "all";
};
